module.exports = __webpack_public_path__ + "static/media/BariolLight-Italic.7c26eaa9.woff2";